
import speedkitHydrate from '#speedkit/hydrate'
import SpeedkitPicture from '#speedkit/components/SpeedkitPicture'
import { mapActions } from 'vuex'
import pricing from '~/mixins/pricing'

export default {
  layout: 'article-full',
  components: {
    LogoCloud: speedkitHydrate(() => import('@/components/global/LogoCloud.vue')),
    UpgradeModal: speedkitHydrate(() => import('@/components/app/modal/UpgradeModal.vue')),
    SpeedkitPicture,
  },
  head: {
    htmlAttrs: {
      lang: 'en',
    },
    title: 'EchoWave Pricing 💰',
    meta: [
      {
        hid: 'description',
        name: 'description',
        content: 'Start for free or upgrade to our paid plan for $19/month! Make your video stand out on Instagram feeds by adding custom wave animations. We are here to help, always ready to answer your questions',
      },
    ],
  },
  data() {
    return {
      billingCycle: 'Monthly',
    }
  },
  mixins: [pricing],
  methods: {
    ...mapActions(['showUpgradeModal']),
  },
}
